<template>
  <div>
    <Header_Fixed />
    <div class="home-page container mobile-first">
      <div class="slogan">
        <h1 class="slogan-text">{{pageContent.title}}</h1>
        <p class="slogan-subtext" v-html="pageContent.description">

        </p>
      </div>
      <div class="button-filter-mobile rounded-btn">
        <button
          type="text"
          @click="$store.commit('setShowFilter', !isFilterShow)"
          class="button-flex"
        >
          <div class="filter-objects-mobile">Фільтр об’єктів</div>
          <div class="circle">
            <IconBase height="16" width="16">
              <FilterIcon />
            </IconBase>
          </div>
        </button>

        <el-dialog
          @close="$store.commit('setShowFilter', false)"
          :visible.sync="isFilterShow"
          width="100%"
          center
        >
          <div class="style-mobile-filter">Основний Фільтр</div>
          <FiltersMobile />
          <span slot="footer" class="dialog-footer filter-dialog-footer">
            <el-button
              class="buttons-filter-mobile rounded-btn blue"
              :class="(isFlatFilterUsed)?'active':'disable'"
              type="primary"
              @click="
                if(showFilterRemoveList = true){
                  
                }
                showFilterRemoveList = false
                resetFlatFilter()
               
              "
             
              >Очистити</el-button
            >
            <el-button
              type="primary"
              @click="$store.commit('setShowFilter', false)"
              class="buttons-filter-mobile"
              >Показати ({{ pagination.total }})</el-button
            >
          </span>
        </el-dialog>
      </div>
      <Filters />
      <Sorting
        id="sorting-home"
        :count="pagination.total"
        :sort-value="sort"
        title="знайдено об’єктів"
        @change="$store.dispatch('changeFlatsSorting', $event)"
      />
      <div class="apartment-list">
        <Apartment v-for="item in flatsList" :item="item" :key="item.id" />
      </div>
      <Pagination
        :itemsOnPage="15"
        :totalItems="pagination.total"
        :current-page="pagination.page"
        @change="paginationHandler($event)"
      />
      <!--      Background-->
      <div>
        <div class="home-main-img">
          <img src="@/assets/images/home-main.png" alt="#" />
        </div>
        <div class="home-main-img-mobile">
          <img src="@/assets/images/mobile/mobile-back.png" alt="#" />
        </div>
        <!-- 600 - offsetTop , (750, 836) - height of (left, right) image,  700 design offset between circles  -->
        <div
          class="main-left-bottom"
          v-for="(_, index) in Math.round(docHeight / 1000)"
          :style="{
            top: 2986 * index + 600 + 'px',
          }"
        >
          <img src="@/assets/images/left-circle.png" alt="" />
        </div>
        <div
          class="main-right-midl"
          v-for="(_, index) in Math.round(docHeight / 1000)"
          :style="{
            top: 2986 * index + 2050 + 'px',
          }"
        >
          <img src="@/assets/images/right-circle.png" alt="" />
        </div>
      </div>
      <div class="main-right-top">
        <img alt="" src="@/assets/images/main-right-top.png"  />
      </div>
    </div>
  </div>
</template>

<script>
import FilterIcon from '@/components/icons/FilterIcon'
import Filters from '@/components/home/Filters'
import Apartment from '@/components/home/apartment/Apartment'
import Sorting from '@/components/common/Sorting'
import Pagination from '@/components/common/Pagination'
import Header_Fixed from '@/components/common/Header_Fixed'
import { mapGetters, mapState } from 'vuex'
import FiltersMobile from '@/components/home/FiltersMobile'
import IconBase from '@/components/icons/IconBase'
import {Api} from "@/services/AxiosService";
export default {
  name: 'Home',
  async created() {
    this.$store.dispatch('show');
    await this.$store.dispatch('fetchFlatsList')
    const {data: {data}} =  await Api.fetchPageContentBySlug('home')
    this.pageContent = data
    this.$store.dispatch('hide');
  },
  components: {
    IconBase,
    Header_Fixed,
    Sorting,
    FilterIcon,
    Apartment,
    Filters,
    Pagination,
    FiltersMobile,
  },
  computed: {
    ...mapState({
      isFilterShow: (state) => state.filterParams.showFilter,
    }),
    ...mapGetters({
      flatsList: 'getFlatsList',
      docHeight: 'getDocumentHeight',
      flatParams: 'getFlatsFilterParams',
      flatFilter: 'getFlatsFilter',
      defaultFlatsFilter: 'getDefaultFlatsFilter',
      isFlatFilterUsed: 'isFlatFilterUsed',
      sort: 'getFlatsSorting',
      pagination: 'getFlatsPagination',
      currency: 'getGlobalCurrency',
      usdCourse: 'getUsdCourse',
      favoriteFlats: 'getFavoriteFlatList',
    }),
  },
  watch: {
    isFlatFilterUsed(newValue) {
      if (!newValue) this.showFilterRemoveList = false
    },
  },

  data() {
    return {
      showFilterRemoveList: false,
      pageContent: {}
    }
  },

  methods: {
    async paginationHandler(page) {
      await this.$store.dispatch('changeFlatsPagination', { page })

      const myEl = document.querySelector('#sorting-home')
      setTimeout(() => {
        window.scrollTo({
          top: myEl.offsetTop - 20,
          behavior: 'smooth',
        })
      }, 100)
    },
    sortHandler(event) {
      this.$store.dispatch('changeFlatsSorting', event)
    },

    resetFlatFilter() {
      //reset all filter filter. null parameter is required
      this.$store.dispatch('changeFlatsFilter', null)
    },
    filterHandler(value) {
      this.$store.dispatch('changeFlatsFilter', {
        ...this.flatFilter,
        ...value,
      })
    },
  },
}
</script>
